const defaultParam = {
  numberOfQuestion: 3,
  preparingTime: 60,
  answeringTime: 60,
  readingQuestionTime: 20,
  limitPreparationTime: true,
  limitAnsweringTime: true,
}
let checkboxParams =  ["limitPreparationTime","limitAnsweringTime"];

export {defaultParam, checkboxParams};